import { render } from "./appContent.vue?vue&type=template&id=34f636f6&scoped=true"
import script from "./appContent.vue?vue&type=script&lang=js"
export * from "./appContent.vue?vue&type=script&lang=js"

import "./appContent.vue?vue&type=style&index=0&id=34f636f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f636f6"]])

export default __exports__